$(document).ready(function () {
  function productCalculator() {
    let calcWrap = $(".calc");

    let paperWidth = calcWrap.find('[name="calc[paperwidth]"]').val();

    if ($(".product-template").length) {
      calcWrap.find('[name="calc[paperwidth]"]').val(paperWidth * 100);
    }

    $(".calc__btn").click(function () {
      let length = calcWrap.find('[name="calc[length]"]').val(),
        height = calcWrap.find('[name="calc[height]"]').val(),
        paperLength = calcWrap.find('[name="calc[paperlength]"]').val(),
        paperPattern =
          calcWrap.find('[name="calc[paperpattern]"]').val() != 0
            ? calcWrap.find('[name="calc[paperpattern]"]').val() / 100
            : 0.01,
        paperWidth = calcWrap.find('[name="calc[paperwidth]"]').val() / 100;

      let productFullPattern = Math.floor(paperLength / paperPattern);
      let neededPatternSteps = Math.ceil(height / paperPattern);
      let coverCount = Math.floor(productFullPattern / neededPatternSteps);
      let coverNeeded = Math.ceil(length / paperWidth);

      let result = coverNeeded / coverCount;
      let roundedResult = Math.ceil(result);

      if (result) {
        $(".calc__result").show();
        calcWrap.find("span").html(result.toFixed(2));
        calcWrap.find("b").html(roundedResult);
      } else {
        $(".calc__result").hide();
      }
    });
  }

  productCalculator();

  $("body").on("click", ".ajax-cart__checkout-link", function (e) {
    e.preventDefault();
    if ($("#agree").prop("checked")) {
      location.href = Shopify.routes.root + "checkout";
    } else {
      alert("Palun nõustuge e-poe tingimustega!");
    }
  });

  function productContactForm() {
    $(".ordering__form, #calc_form").on("submit", function () {
      let data = $(this)
        .serializeArray()
        .filter(
          (el) =>
            el.name.includes("contact") &&
            !(el.name.includes("product_name") || el.name.includes("sku"))
        );
      sessionStorage.setItem("ordering", JSON.stringify(data));
    });

    if ($(".ordering").length && sessionStorage.getItem("ordering")) {
      let data = JSON.parse(sessionStorage.getItem("ordering"));
      data.forEach((el) => $(`.ordering [name="${el.name}"]`).val(el.value));
      data.forEach((el) => $(`#calc_form [name="${el.name}"]`).val(el.value));
      $("#ordering-save").prop("checked", true);
    }
  }

  productContactForm();

  if ($("#calc_form").length) {
    if (location.href.indexOf("#calc_form") !== -1) {
      $("#contact_form").find(".ordering__success").hide();
      setTimeout(() => {
        $(".calc__dropdown").click();
      }, 1000);
    }
    if (location.href.indexOf("#contact_form") !== -1) {
      $("#calc_form").find(".ordering__success").hide();
    }
    $(".telli__calc").click(function (e) {
      e.preventDefault();
      let form = $(this).closest("form");
      let price = +$(this).attr("data-price");
      let findBlank = false;
      let length = $(form).find('input[name="contact[length]"]').val();
      let width = $(form).find('input[name="contact[weight]"]').val();
      if (length.length && width.length) {
        let result =
          (+length.replace(",", ".") * +width.replace(",", ".") * price) / 100;
        $(".telli__result span").html(result.toFixed(2));
      }
    });
  }
});

$(window).bind("mousewheel", function (event) {
  let $header = $(".header__mobile-container");

  if (event.originalEvent.wheelDelta >= 0 || event.originalEvent.deltaY < 0) {
    $header.removeClass("transform");
  } else {
    $header.addClass("transform");
  }
});

$("[data-modal]").click(function (e) {
  if (!$(e.target).closest("[data-modal-inner]").length) {
    $("[data-modal]").removeClass("active");
  }
});
$(document).on("click", "[data-wishlist-btn]", function (e) {
  let btn = $(e.target).closest("[data-wishlist-btn]");
  if (window.customerId) {
    if ($(btn).hasClass("active")) {
      $(btn).removeClass("active");
      window.updateWishlist(null, $(btn).attr("data-product-handle"));
    } else {
      $(btn).addClass("active");
      window.updateWishlist($(btn).attr("data-product-handle"), null);
    }
  } else {
    $(".l-popup").addClass("active");
  }
});
$(".header__wish").click(function (e) {
  e.preventDefault();
  if (window.customerId) {
    location.href = $(this).attr("href");
  } else {
    $(".l-popup").addClass("active");
  }
});
$("[data-modal-close]").click(function () {
  $(this).closest("[data-modal]").removeClass("active");
});

$(document).on("change", ".wish-form__check", function () {
  if ($(".wish-form__check:checked").length) {
    $(".a-wishlist__btns").addClass("active");
  } else {
    $(".a-wishlist__btns").removeClass("active");
  }
});

$("[data-wishlist-remove]").click(() => {
  let ids = [];
  $(".wish-form__check:checked").each(function () {
    ids.push($(this).val());
    $(this).closest(".a-wishlist__item").hide();
  });
  window.updateWishlist(null, ids);
  $(".wish-form__check").prop("checked", false);
});
$(document).on("click", ".wish-form__remove", function (e) {
  console.log($($(e.target).closest(".wish-form__remove")).attr("data-handle"));
  $(e.target).closest(".a-wishlist__item").hide();
  window.updateWishlist(
    null,
    $($(e.target).closest(".wish-form__remove")).attr("data-handle")
  );
});

$("[data-wishlist-add]").click(function () {
  let data = {};
  data.items = [];
  $(".wish-form__check:checked").each(function () {
    let id = $(this).closest(".wish-form").find('select[name="id"]').val();
    data.items.push({
      id: +id,
      quantity: 1,
    });
  });
  $.ajax({
    type: "post",
    url: "/cart/add.js",
    data,
    dataType: "json",
    success: function () {
      location.href = "/cart";
    },
  });
});

$("[data-wishlist-order]").click(function () {
  let items = [];
  $(".wish-form__check:checked").each(function () {
    let sku = $(this)
      .closest(".wish-form")
      .find("select option:checked")
      .attr("data-sku");
    let title = $(this)
      .closest(".a-wishlist__item")
      .find(".wish-form__title")[0].innerText;
    items.push(`${title}:${sku}`);
  });
  $("#telliWishlist").val(items.join(", "));
  $(".telli-modal").addClass("active");
});
$(".wish-form__telli").click(function (e) {
  e.preventDefault();
  let items = [];
  let sku = $(this)
    .closest(".a-wishlist__item")
    .find("select option:checked")
    .attr("data-sku");
  let title = $(this).attr("data-title");
  items.push(`${title}:${sku}`);
  $("#telliWishlist").val(items.join(", "));
  $(".telli-modal").addClass("active");
});

$(".wish-form__options input").on("change", function () {
  let option = $(this).val();
  let id = $(this)
    .closest(".variants")
    .find(`select option[data-title="${option}"]`)
    .attr("value");
  if (id) {
    $(this).closest(".variants").find(`select`).val(id);
  }
});
